import { useUiPreferences } from '../useUiPreferences';
import { Section, SegmentedRow, SliderRow, ToggleRow } from '../SettingsRows';

const DEFAULTS = { 'ui.playback.stream_quality': 'FLAC', 'ui.playback.download_quality': 'AAC 256', 'ui.playback.crossfade': '6', 'ui.playback.gapless': 'true', 'ui.playback.normalize': 'false' };

export function PlaybackTab(): React.JSX.Element {
    const [prefs, save] = useUiPreferences(DEFAULTS);

    return (
        <>
            <Section title="Quality">
                <SegmentedRow
                    label="Streaming"
                    desc="Quality used on your home network."
                    options={['FLAC', 'AAC 256', 'Saver']}
                    value={prefs['ui.playback.stream_quality']}
                    onChange={(v) => save({ 'ui.playback.stream_quality': v })}
                />
                <SegmentedRow
                    label="Downloads"
                    desc="Quality stored for offline listening."
                    options={['FLAC', 'AAC 256']}
                    value={prefs['ui.playback.download_quality']}
                    onChange={(v) => save({ 'ui.playback.download_quality': v })}
                />
            </Section>
            <Section title="Transitions">
                <SliderRow
                    label="Crossfade"
                    desc="Overlap between two tracks."
                    min={0}
                    max={12}
                    step={1}
                    unit="sec"
                    value={Number(prefs['ui.playback.crossfade']) || 0}
                    onChange={(v) => save({ 'ui.playback.crossfade': String(v) })}
                />
                <ToggleRow
                    label="Gapless playback"
                    desc="No silence between tracks on live albums."
                    value={prefs['ui.playback.gapless'] === 'true'}
                    onChange={(v) => save({ 'ui.playback.gapless': String(v) })}
                />
                <ToggleRow
                    label="Normalize volume"
                    desc="Even out loudness across albums."
                    value={prefs['ui.playback.normalize'] === 'true'}
                    onChange={(v) => save({ 'ui.playback.normalize': String(v) })}
                />
            </Section>
        </>
    );
}
